import styled from "styled-components";
import { drakGreen } from "../../../../Reusable/Colors";

export const SkarduParentDiv = styled.div`
  h1 {
    color: ${drakGreen};
    font-size: 2.2rem;
  }
`;

export const FelxBoxDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;
